import React from 'react';
import Wizard from '../components/Wizard';
import Pageheader from '../utils/headerHelment';

const WizardPage = () => {
    return (
        <>
            <Pageheader title="LENS - Wizard" />
            <Wizard />
        </>
    );
};

export default WizardPage;
